import { Component } from "react"

/* Modal */
import Modal from "react-modal"

/* Components */
import { Icon } from "../../components"

/* Icons */
import { LoadingOutlined } from "@ant-design/icons"

/* REST API */
import { assign } from "../../api/Queue"

/* Widgets */
import { toast } from "../common"

Modal.setAppElement("#root")


/* Widget Assign Modal — the ticket is handed over to a master of the point, or taken away
   from the one it stands on. It is opened by the reference:
   this._assign.current.open(item, members) */
class AssignModal extends Component {

    constructor() {
        super()

        this.state = {
            visible: false,
            saving: false,

            id: 0,
            memberID: 0,
            members: []
        }
    }

    /* Open the form on the master the ticket stands on now */
    open = (item, members) => {
        this.setState({ visible: true, saving: false, id: item.id, memberID: item.memberID ? parseInt(item.memberID) : 0, members })
    }

    /* Close the form */
    close = () => {

        /* The request is already on its way */
        if (this.state.saving) {
            return
        }

        this.setState({ visible: false })
    }

    /* Hand the ticket over */
    save = () => {

        /* Fields */
        const { saving, id, memberID } = this.state
        const { onSaved } = this.props

        /* The request is already on its way */
        if (saving) {
            return
        }

        this.setState({ saving: true })

        assign({ id, memberID }).then(response => {

            if (response && response.status === 200) {

                this.setState({ visible: false, saving: false })

                toast.success(memberID ? "Мастер назначен" : "Мастер снят с талона")

                if (onSaved) {
                    onSaved()
                }
            }
            else {
                this.setState({ saving: false })
                toast.error("Не удалось назначить мастера")
            }
        }).catch(() => {
            this.setState({ saving: false })
            toast.error("Не удалось назначить мастера")
        })
    }

    render = () => {

        /* Fields */
        const { visible, saving, memberID, members } = this.state

        return (
            <Modal
                isOpen={visible}
                onRequestClose={this.close}
                className="queue-form-modal small"
                overlayClassName="queue-form-overlay"
                closeTimeoutMS={200}
            >

                <div className="queue-form-header">
                    <h2>Мастер талона</h2>
                    <div onClick={this.close} className="queue-form-close">
                        <Icon name="close" size={11} width={2.2} />
                    </div>
                </div>

                <div className="queue-form-body">

                    <div className="queue-form-label">Команда точки</div>

                    <div className="queue-filter-list">

                        <div
                            onClick={() => this.setState({ memberID: 0 })}
                            className={`queue-filter-option ${memberID === 0 ? "active" : ""}`}
                        >
                            Без мастера
                        </div>

                        {members.map(member =>
                            <div
                                key={`${member.id}`}
                                onClick={() => this.setState({ memberID: parseInt(member.id) })}
                                className={`queue-filter-option ${memberID === parseInt(member.id) ? "active" : ""}`}
                            >
                                {member.name}
                            </div>
                        )}

                        {members.length === 0 && <div className="queue-filter-empty">В команде точки никого нет</div>}

                    </div>

                </div>

                <div className="queue-form-footer">
                    <div onClick={this.close} className="queue-form-button light">Отмена</div>
                    <div onClick={this.save} className={`queue-form-button ${saving ? "disabled" : ""}`}>
                        {saving ? <LoadingOutlined /> : "Сохранить"}
                    </div>
                </div>

            </Modal>
        )
    }
}

export default AssignModal
